require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-introduction-data-science-life-cycle.json") })
        }
      }, "path---posts-introduction-data-science-life-cycle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-introduction-data-science-life-cycle!./.cache/json/posts-introduction-data-science-life-cycle.json
// module id = 384
// module chunks = 231608221292675